import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getListings } from '../services/listingService';
import ListingCard from '../components/ListingCard';
import '../styles/Listings.css';

const Listings = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchListings = async () => {
            try {
                const data = await getListings();
                setListings(data);
                setLoading(false);
            } catch (err) {
                setError('Failed to load listings');
                setLoading(false);
            }
        };

        fetchListings();
    }, []);

    if (loading) {
        return (
            <div className="listings-container">
                <div className="loading">Loading listings...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="listings-container">
                <div className="error">{error}</div>
            </div>
        );
    }

    return (
        <div className="listings-container">
            <div className="listings-header">
                <h1>Browse Listings</h1>
            </div>
            <div className="listings-grid">
                {listings.map(listing => (
                    <ListingCard 
                        key={listing.id} 
                        listing={listing}
                        onDelete={() => {}} // Empty function since non-owners can't delete
                        isOwner={false}
                    />
                ))}
            </div>
        </div>
    );
};

export default Listings; 